import { render } from "./TargetComponent.vue?vue&type=template&id=7955bd89"
import script from "./TargetComponent.vue?vue&type=script&lang=js"
export * from "./TargetComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__